module.exports = __webpack_public_path__ + "img/trash.e2619be1.svg";